<div class="schemaContent"> 
    <div class="schemaHeader" i18n>Schema Info</div>          
  
      <mat-form-field class="my-form-field schemaNameFilterField">
          <mat-label>Filter</mat-label>
          <input matInput (keyup)="schemaNameFilter($event)">
        </mat-form-field>
  
      <div class="container">
        <table mat-table [dataSource]="schemaInfoDataSource" matSort class="schemaTable">
          <!-- Checkbox Column -->          
          <ng-container matColumnDef="num">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Sl. No. </th>
            <td mat-cell *matCellDef="let element; let i = index"> {{i + 1}} </td>
          </ng-container>

          <ng-container matColumnDef="objname">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Object Name </th>
            <td mat-cell *matCellDef="let element"> {{element.name}} </td>
          </ng-container>

          <ng-container matColumnDef="objtyp">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Object Type </th>
            <td mat-cell *matCellDef="let element"> {{element.objectType}} </td>
          </ng-container>

          <ng-container matColumnDef="instversion">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Installed Version </th>
            <td mat-cell *matCellDef="let element"> {{element.installedVersion}} </td>
          </ng-container>

          <ng-container matColumnDef="avlbversion">
            <th mat-header-cell *matHeaderCellDef mat-sort-header i18n> Available Version </th>
            <td mat-cell *matCellDef="let element"> {{ element.availableVersion }} </td>            
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
            <td mat-cell *matCellDef="let element"> {{ element.status }} </td>
          </ng-container>  

          <tr mat-header-row *matHeaderRowDef="schemaInfo"></tr>
          <tr mat-row *matRowDef="let row; columns: schemaInfo;"></tr>
        </table>
      </div>
  
      <mat-divider></mat-divider>
  
      <div class="cacheQuestion" i18n>Confirm Schema Update</div> 
      <div class="cacheWarning" i18n>Initiating the update schema will recreate/update all cSmobile tables. Existing data in the table will be lost. Are you sure you want to proceed?</div> 
  
      <div class="buttonContent">
        <button mat-raised-button type="button" color="primary" (click)="confirmRefreshSchema()" i18n>UPDATE</button>
      </div>   
      
      <div class="pageOverlay" *ngIf="inProgress">
        <mat-spinner strokeWidth="6" [value]="value"></mat-spinner>
      </div>
  </div>